import Splide from '@splidejs/splide';

(() => {
  const slider = document.querySelector('.hero-splide-slider .splide');
  if (!slider) return;

  const heroSlider = new Splide(slider, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    arrows: false,
    pagination: true,
    autoplay: true,
    interval: 5000,
  });

  heroSlider.mount();
})();
